module.exports = " <div class=hero _v-72744d6e=\"\"> <div class=wrap _v-72744d6e=\"\"> <div class=text _v-72744d6e=\"\">Wooyun Drops</div> <div class=minitext _v-72744d6e=\"\">学而时习之，不亦说乎？</div> </div> <div class=search-unit _v-72744d6e=\"\"> <input type=text class=search-input v-model=search _v-72744d6e=\"\"> </div> </div> <drop-list :search.sync=search _v-72744d6e=\"\"></drop-list> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/8.5.3/vue-loader/lib/template-rewriter.js?id=_v-72744d6e!./~/.npminstall/vue-loader/8.5.3/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndexContent.vue
 ** module id = 26
 ** module chunks = 2
 **/